// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s0nk","controls":"styles_controls__1u83Z","charLimit":"styles_charLimit__3Il3N","input":"styles_input__3fbmL","send":"styles_send__3GhLh"};